const isDT = () => {
    const mainId = localStorage.getItem("_mainId")
    return mainId == '7529c2408517424abee9e166cb4ac6ec'
}

export default {
    isDT
}